import {NotificationApi} from '@/api/notification-api';
import {mapActions, mapGetters} from 'vuex';

export const NotificationUtils = {
  computed: {
    ...mapGetters({
      notifications: 'notifications'
    }),

    hasActiveNotifications () {
      return this.notifications.numberOfActive > 0;
    }
  },

  methods: {
    ...mapActions(['setNotifications']),

    getActiveNotifications () {
      let request = NotificationApi.getActiveNotifications();
      request.then(response => {
        this.setNotifications({
          activeNotifications: response.body.content.slice(0, 5),
          numberOfActive: response.body.totalElements,
          lastPolledAt: new Date().valueOf()
        })
      });
      return request;
    },

    /**
     * @param {number} notificationId
     * @param {boolean} handled
     */
    setNotificationHandled (notificationId, handled = true) {
      NotificationApi.updateNotification(notificationId, {handled: handled})
        .then(() => {
          this.$emit('update');
          this.getActiveNotifications();
        });
    },

    /**
     * @param {number} notificationId
     * @param {Date} silentUntil
     */
    setNotificationSilentUntil (notificationId, silentUntil) {
      NotificationApi.updateNotification(notificationId, {silentUntil: silentUntil})
        .then(() => {
          this.$emit('update');
          this.getActiveNotifications();
        });
    },

    /**
     * @param {NotificationDto} notification
     */
    getReadableNotificationType (notification) {
      let type = '';

      switch (notification.type) {
        case 'COULD_NOT_SEND_MAIL': type = this.trans('notifications.type.couldNotSendMail'); break;
        case 'COULD_NOT_PREPARE_BOOKING_OWNER_MAIL': type = this.trans('notifications.type.couldNotPrepareBookingOwnerMail'); break;
        case 'NEW_CANCELED_BOOKING': type = this.trans('notifications.type.newCanceledBooking'); break;
        case 'NEW_OBJECT': type = this.trans('notifications.type.newObject'); break;
        case 'NEW_SURVEY_RESULT': type = this.trans('notifications.type.newSurveyResult'); break;
        case 'STAYIN_IMPORT_JOB_FAILED': type = this.trans('notifications.type.stayinImportJobFailed'); break;
      }

      return type;
    }
  }
};
